export default "__VITE_ASSET__Bn7_Ynl4__"